export const START_OF_WEEK = "startOfWeek";
export const TIME_FORMAT = "timeFormat";
export const DEFAULT_DURATION = "defaultDuration";
export const DEFAULT_VISIBILITY = "defaultVisibility";
